<script setup>
import { inject } from 'vue';

const { userGuide } = inject('config');
</script>

<template>
  <button class="c-icon-action" type="button">
    <svg aria-hidden="true" class="c-icon-action__svg" focusable="false">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#user-guide"></use>
    </svg>
    <span class="c-icon-action__text">{{ userGuide.title }}</span>
  </button>
</template>

<style lang="scss">
@import '@/ui/styles/functions/functions';
@import '@/ui/styles/settings/colors';
@import '@/ui/styles/settings/fonts';
@import '@/ui/styles/settings/units';
@import '@/ui/styles/mixins/buttons';
@import '@/ui/styles/mixins/focus';
@import '@/ui/styles/mixins/fonts';

.c-icon-action {
  @include removeDefaultButtonStyling();
  @include iconButton(rem(70px));
  @include h3-style;
  color: $color-brand-one;
  cursor: pointer;

  > svg {
    z-index: 3;
    margin-right: -#{$spacing-medium};
  }

  &:hover {
    text-decoration: underline;
  }
}

.c-icon-action__text {
  padding: rem(8px) $spacing-medium rem(8px) rem(23px);
  background-color: $white;
  border: $border-width-thin solid $ssen-light-blue;
  border-bottom-right-radius: rem(8px);
  line-height: 1;
}
</style>
